"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderSkillRating = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const react_intl_1 = require("react-intl");
const SliderSkillRating_style_1 = require("./SliderSkillRating.style");
const SliderSkillRating = ({ min = 1, max = 5, skillTagValue, skillTagRating, skills, setSkills, breakpoints, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const { lg } = breakpoints;
    const marks = {
        1: intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.beginner}` }),
        2: lg ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.basics}` }) : '',
        3: lg
            ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.preintermediate}` })
            : '',
        4: lg ? intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.intermediate}` }) : '',
        5: intl.formatMessage({ id: `profile.resume.skill.skill_level_${types_1.SkillTagSkillLevel.expert}` }),
    };
    return ((0, jsx_runtime_1.jsx)(SliderSkillRating_style_1.SkillSliderWrapper, { defaultValue: skillTagRating || 1, marks: marks, min: min, max: max, step: 1, onAfterChange: (value) => {
            const valueAsNumber = Array.isArray(value) ? value[0] : value;
            const previousSkillIndex = skills.findIndex(skill => skill.value === skillTagValue);
            if (previousSkillIndex >= 0) {
                const skillArrayToModify = [...skills];
                const newSkillItem = { ...skills[previousSkillIndex], rating: valueAsNumber };
                skillArrayToModify[previousSkillIndex] = { ...newSkillItem };
                setSkills([...skillArrayToModify]);
            }
        }, range: false, tooltipVisible: false }));
};
exports.SliderSkillRating = SliderSkillRating;
